<script>
  /* Executable code section of the program */
  import {
    isEmptyChatBox,
    temporalChatAttendee,
    isOpenChat,
    allChats
  } from "../../apis/storage";
  //Components importation
  import ChatCards from "../Cards/ChatCards.svelte";
  import UnreadChatCard from "../Cards/UnreadChatCard.svelte";
  import ChatComponent from "./ChatComponent.svelte";

  //Auxiliary varibales
  export let activeChats;
  $allChats = activeChats;
  let typedValue;

  //Function to search chats
  function normalize(text) {
    return text
      .normalize("NFD") // Separates accents
      .replace(/[\u0300-\u036f]/g, "") // Removes accents
      .toLowerCase()
      .trim();
  }

  const chatSearch = (array, typedValue) => {
    const normalizedSearch = normalize(typedValue);

    $allChats = array.filter((item) => {
      const name = normalize(item.name || "");
      const surname = normalize(item.surname || "");

      return (
        name.includes(normalizedSearch) || surname.includes(normalizedSearch)
      );
    });
  };

  /* End of the section */
</script>

<!-- Section to place the HTML code -->
<section class="pricipalSection">
  {#if $isOpenChat}
    <div class="chatContainer">
      <ChatComponent />
    </div>
  {:else}
    <div class="inputContainer">
      <div class="form-floating">
        <input
          type="text"
          class="form-control"
          id="floatingInput"
          placeholder="Search"
          bind:value={typedValue}
          on:input={() => chatSearch(activeChats, typedValue)}
        />
        <label for="floatingInput">Search</label>
      </div>
    </div>
    {#each $allChats as chat}
      <div class="cardPhoneContainer">
        <ChatCards {chat} />
      </div>
    {/each}
  {/if}
</section>

<!-- End of the section -->
<style>
  /* Section to place the code styles */
  /* Principal styles */
  .pricipalSection {
    width: 100%;
    height: 80vh;
    overflow: auto;
  }
  /* Input container */
  .inputContainer {
    padding: 10px;
  }

  /* /////////Tablets///////// */
  @media (min-width: 700px) and (max-width: 1100px) {
  }
  /* /////////Cellphones ///////// */
  @media (max-width: 700px) {
  }

  /* End of the section */
</style>
